import { Checkbox } from '@mantine/core';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Flex, Grid } from '@zorro/web/design-system';

/* Relative, not the `@zorro/web/shared-ui` barrel: the barrel re-enters this
   same library and drags in EmployeesDatatable (and its ESM-only `nuqs`), which
   makes PlanFilter unimportable in isolation. */
import { CarrierLogoNext } from '../../CarrierLogoNext';
import classNames from './PlanFilter.module.scss';

export const CarrierFilters = ({
  filterOptions,
  mapCarrierNameToLogo,
  selectedFilters,
}: {
  filterOptions: Set<string> | undefined;
  mapCarrierNameToLogo: Map<string, string>;
  selectedFilters: string[];
}) => {
  if (!filterOptions) {
    return null;
  }
  const sortedCarrierNames = Array.from(filterOptions).sort(
    (carrierNameA, carrierNameB) => {
      const lowerCaseA = carrierNameA.toLowerCase();
      const lowerCaseB = carrierNameB.toLowerCase();
      if (lowerCaseA < lowerCaseB) return -1;
      if (lowerCaseA > lowerCaseB) return 1;
      return 0;
    }
  );
  return (
    <Grid columns={2} gap="sm" w="100%">
      {sortedCarrierNames.map((carrierName) => {
        const logoUrl = mapCarrierNameToLogo.get(carrierName);
        return (
          <Grid.Col span={1} key={carrierName}>
            <Tooltip label={carrierName} position="top" withinPortal={false}>
              <Checkbox.Card
                pos="relative"
                checked={selectedFilters?.includes(carrierName)}
                value={carrierName}
                className={classNames.checkboxCard}
              >
                <Flex h="48px" align="center" justify="center">
                  <CarrierLogoNext
                    plan={{ carrierName, logoUrl }}
                    sizes="xs"
                    width={147}
                    height={40}
                    fw={400}
                  />
                </Flex>
              </Checkbox.Card>
            </Tooltip>
          </Grid.Col>
        );
      })}
    </Grid>
  );
};
